import { Container, type Theme, type TypographyProps, styled, useTheme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { type ReactNode } from 'react';
import { Divider, SectionContainer, SectionHeading } from '#styled.ts';

export const FourColumnGrid = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gridTemplateRows: 'min-content 1fr',
}));

export const ThreeColumnsOnDesktop = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    gridColumnEnd: 5,
  },
  gridColumnEnd: 4,
  gridColumnStart: 1,
  gridRowStart: 1,
}));

export enum SectionColor {
  Black = '#111',
  DarkGrey = '#333',
  Default = 'initial',
  Grey = '#ddd',
}

export type SectionProps = {
  children: ReactNode | ReactNode[];
  className?: string;
  color?: SectionColor;
  sx?: SystemStyleObject<Theme>;
  threeQuarterWidthOnDesktop?: boolean;
  title?: ReactNode | ReactNode[];
  titleVariant?: TypographyProps['variant'];
};

export const Section = ({
  children,
  className,
  color = SectionColor.Default,
  sx,
  threeQuarterWidthOnDesktop,
  title,
  titleVariant = 'h6',
}: SectionProps) => {
  const theme = useTheme();

  return (
    <SectionContainer
      className={className}
      sx={{
        ...sx,
        backgroundColor: color,
      }}
    >
      <Container disableGutters maxWidth="xl">
        {threeQuarterWidthOnDesktop ? (
          <FourColumnGrid>
            <ThreeColumnsOnDesktop>
              {title ? (
                <>
                  <SectionHeading
                    sx={color === SectionColor.DarkGrey ? { color: theme.mainTextSecondary } : undefined}
                    variant={titleVariant}
                  >
                    {title}
                  </SectionHeading>
                  <Divider />
                </>
              ) : undefined}
              {children}
            </ThreeColumnsOnDesktop>
          </FourColumnGrid>
        ) : (
          <>
            {title ? (
              <>
                <SectionHeading
                  sx={color === SectionColor.DarkGrey ? { color: theme.mainTextSecondary } : undefined}
                  variant={titleVariant}
                >
                  {title}
                </SectionHeading>
                <Divider />
              </>
            ) : undefined}
            {children}
          </>
        )}
      </Container>
    </SectionContainer>
  );
};
